import React, { FC } from 'react';
import { clone, shuffle } from 'lodash';

import BuysideConsensusContainer, {
  CompanyQuestion
} from 'buyside/components/container/CompanyShow/BuysideConsensusContainer';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import {
  useEntityPollQuery,
  useSubmitCompanyQuestionResponseMutation
} from 'interfaces/graphql-typings';

// Shuffle all questions and move any answered questions at the end (12 Jun 2019 - TMA)
const shuffleQuestions = (questions: CompanyQuestion[]): CompanyQuestion[] =>
  shuffle(clone(questions)).sort((a, b): number => {
    if (a?.pollResponseData?.answeredByCurrentUser && !b?.pollResponseData?.answeredByCurrentUser) {
      return 1;
    } else if (
      !a?.pollResponseData?.answeredByCurrentUser &&
      b?.pollResponseData?.answeredByCurrentUser
    ) {
      return -1;
    }
    return 0;
  });

const EntityBuysideConsensus: FC<{ id: string }> = ({ id }) => {
  const { data, loading, error } = useEntityPollQuery({
    variables: { id }
  });

  const [submitCompanyQuestionResponse] = useSubmitCompanyQuestionResponseMutation();

  if (loading || !data || !data?.entity) return <LoadingSpinner size={SIZES.MEDIUM} />;

  if (error) throw error;

  return (
    <BuysideConsensusContainer
      companyQuestions={data.companyQuestions ? shuffleQuestions(data.companyQuestions) : []}
      recordResponse={(questionId: string, answers: string | string[], skipped: boolean) =>
        submitCompanyQuestionResponse({
          variables: { id: questionId, entityId: id, answers, skipped }
        })
      }
      assetId={data.entity.primaryAssetId}
      entity={data.entity}
      showPoll
      showUserDetails={Boolean(data.currentUser?.canViewUserDetails)}
    />
  );
};

export default EntityBuysideConsensus;
